import { NODE_TYPE } from './catalogTaxonomyConstants'

/**
 * Count nodes by type.
 */
export function countSubtreeByType(nodes = []) {
  const counts = {
    global: 0,
    category: 0,
    subcategory: 0,
    subtreeDocuments: 0,
  }

  nodes.forEach((node) => {
    if (node?.type === NODE_TYPE.GLOBAL) counts.global += 1
    else if (node?.type === NODE_TYPE.CATEGORY) counts.category += 1
    else if (node?.type === NODE_TYPE.SUBCATEGORY) counts.subcategory += 1
  })

  counts.subtreeDocuments = nodes.length
  return counts
}

/**
 * Remaining non-archived siblings after removing root from the sibling list,
 * reindexed to sortOrder 0..n-1.
 */
export function buildSiblingReorderUpdates(siblingsOfRoot = [], rootId) {
  const remaining = siblingsOfRoot
    .filter((n) => n && n.id !== rootId && n.isArchived !== true)
    .slice()
    .sort((a, b) => {
      const ao = Number(a.sortOrder) || 0
      const bo = Number(b.sortOrder) || 0
      if (ao !== bo) return ao - bo
      return String(a.name || '').localeCompare(String(b.name || ''), 'uk')
    })

  return remaining.map((node, index) => ({
    id: node.id,
    sortOrder: index,
  }))
}

/**
 * UA confirm lines for delete counts.
 */
export function formatSubtreeDeleteCountsMessage(counts) {
  const lines = []
  if (counts.global > 0) {
    lines.push(
      counts.global === 1
        ? '1 глобальну категорію'
        : `${counts.global} глобальні категорії`
    )
  }
  if (counts.category > 0) {
    lines.push(
      counts.category === 1 ? '1 категорію' : `${counts.category} категорії`
    )
  }
  if (counts.subcategory > 0) {
    lines.push(
      counts.subcategory === 1
        ? '1 підкатегорію'
        : `${counts.subcategory} підкатегорій`
    )
  }
  return lines
}
